import HousePricesLanding from '../../../zoopla/libs/house-prices/landing/src/HousePricesLanding';
export { getServerSideProps } from '../../../zoopla/libs/house-prices/landing/src/HousePricesLanding';

export default HousePricesLanding;
